var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.html)?_c('p',{class:_vm.className,domProps:{"innerHTML":_vm._s(_vm.html)}}):_c('p',{class:_vm.className},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }